import React from "react";
function Credits(){
    return(
        <div>Credits em construção</div>
    )
}
export default Credits